import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import './i18n' // 초기화(부수효과) — 렌더 전에 언어가 정해져 있어야 한다
import './styles/index.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root 를 찾지 못했습니다.')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
